// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowUp_arrow__IKzNT","arrow_hidden":"ArrowUp_arrow_hidden__VVy2s"};